export default __webpack_public_path__ + "static/media/icon1.ca0c144d.svg";